/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CorporatePersonRequestDTO = {
    emailAddress: string;
    firstName: string;
    isSignatory: boolean;
    lastName: string;
    role: CorporatePersonRequestDTO.role;
    userExternalId: string;
    verificationMethod: CorporatePersonRequestDTO.verificationMethod;
};

export namespace CorporatePersonRequestDTO {

    export enum role {
        DIRECTOR = 'DIRECTOR',
        BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
        BOTH = 'BOTH',
        OPERATOR = 'OPERATOR',
    }

    export enum verificationMethod {
        VERIFY_NOW = 'VERIFY_NOW',
        EMAIL_INVITE = 'EMAIL_INVITE',
    }


}
